(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a5-magnum-retreat"]) return;
  try {
    

(() => {
  const root = document.getElementById('a5-magnum');
  if (!root || root.dataset.storyReady) return;
  root.dataset.storyReady = 'true';
  const story = root.querySelector('[data-mgm-scene]');
  const chapters = [...story.querySelectorAll('[data-mgm-chapter]')];
  const dots = [...story.querySelectorAll('[data-mgm-step]')];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const touch = matchMedia('(hover: none) and (pointer: coarse)');
  const clamp = (n, a = 0, b = 1) => Math.max(a, Math.min(b, n));
  const smooth = n => n * n * (3 - 2 * n);
  let queued = false, enabled = false, nearby = true, mobile = false;
  let distance = 1, layoutWidth = 0, resizeTimer;
  const probe = document.createElement('div');
  probe.setAttribute('aria-hidden', 'true');
  probe.style.cssText = 'position:absolute;left:0;top:0;width:0;height:100vh;height:100svh;visibility:hidden;pointer-events:none;overflow:hidden;';
  root.append(probe);

  // Scrolling changes only compositor properties. Never resize earlier content
  // when a sticky header or mobile browser toolbar appears or disappears.
  function render() {
    queued = false;
    if (!enabled) return;
    const progress = clamp(-story.getBoundingClientRect().top / distance);
    const blend = smooth(clamp((progress - .32) / .36));
    story.dataset.mgmProgress = progress.toFixed(3);
    story.dataset.mgmActive = blend < .5 ? '1' : '2';
    chapters.forEach((el, index) => {
      const local = index ? progress - .75 : progress - .25;
      el.style.setProperty('--mgm-alpha', (index ? blend : 1 - blend).toFixed(4));
      el.style.setProperty('--mgm-image-y', (local * (mobile ? 24 : 52)).toFixed(2) + 'px');
      el.style.setProperty('--mgm-copy-y', (-local * (mobile ? 16 : 34)).toFixed(2) + 'px');
      el.style.setProperty('--mgm-copy-alpha', (index
        ? smooth(clamp((progress - .52) / .16))
        : 1 - smooth(clamp((progress - .32) / .16))).toFixed(4));
    });
    dots.forEach((el, index) => el.style.setProperty('--mgm-dot', String(index ? blend : 1 - blend)));
  }
  function request() {
    if (!queued) { queued = true; requestAnimationFrame(render); }
  }
  function configure() {
    layoutWidth = innerWidth;
    mobile = layoutWidth < 750;
    const height = Math.floor(probe.getBoundingClientRect().height || innerHeight);
    const stage = Math.min(height, mobile ? 820 : 900);
    distance = Math.max(1, Math.round(stage * .95));
    enabled = !reduce.matches && CSS.supports('position', 'sticky') && stage >= (mobile ? 570 : 500);
    root.style.setProperty('--mgm-top', '0px');
    root.style.setProperty('--mgm-stage-height', stage + 'px');
    root.style.setProperty('--mgm-scroll-distance', distance + 'px');
    story.classList.toggle('is-motion', enabled);
    root.dataset.mgmMotion = enabled ? 'scroll' : 'static';
    if (!enabled) {
      chapters.forEach(el => ['--mgm-alpha', '--mgm-image-y', '--mgm-copy-y', '--mgm-copy-alpha']
        .forEach(name => el.style.removeProperty(name)));
    }
    // Purchase links need header clearance, independently of the story geometry.
    const headers = [...document.querySelectorAll('sticky-header,.section-header,.header-wrapper')];
    const headerHeight = Math.min(height * .3, Math.max(0, ...headers.map(el => el.offsetHeight)));
    document.documentElement.style.setProperty('--mgm-product-offset', Math.round(headerHeight) + 'px');
    request();
  }
  root.querySelectorAll('[data-mgm-details]').forEach(link => {
    const info = document.querySelector('[id^="ProductInfo-"]');
    if (info) link.href = '#' + info.id;
  });
  configure();
  if (typeof IntersectionObserver === 'function') {
    const observer = new IntersectionObserver(entries => {
      nearby = entries[0].isIntersecting;
      request();
    }, { rootMargin: '150px 0px' });
    observer.observe(story);
  }
  addEventListener('scroll', () => { if (nearby) request(); }, { passive: true });
  addEventListener('resize', () => {
    // Height-only events on phones are usually browser chrome, not a new layout.
    if ((mobile || touch.matches) && Math.abs(innerWidth - layoutWidth) < 2) return;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(configure, 160);
  }, { passive: true });
  reduce.addEventListener('change', configure);
})();



(()=>{const p=document.getElementById('mgm-player'),v=document.getElementById('mgm-film'),d=document.getElementById('mgm-landscape-dialog');if(!p||!v||!d||p.dataset.ready)return;p.dataset.ready='true';const stage=d.querySelector('.mgm-l-stage'),toggles=p.querySelectorAll('[data-mgm-toggle]'),mute=p.querySelector('[data-mgm-mute]'),full=p.querySelector('[data-mgm-full]'),seek=p.querySelector('input'),time=p.querySelector('output'),message=p.querySelector('.mgm-message');const icons={"play":"<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m8 5 11 7-11 7Z\" fill=\"currentColor\" stroke=\"none\"/></svg>","pause":"<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8 5v14M16 5v14\" stroke-width=\"4\"/></svg>","sound":"<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11 4 6 8H3v8h3l5 4Zm4 4c3 2 3 6 0 8m3-11c5 4 5 10 0 14\"/></svg>","mute":"<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11 4 6 8H3v8h3l5 4Zm5 5 6 6m0-6-6 6\"/></svg>","full":"<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5\"/></svg>","exit":"<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3 8h5V3m8 0v5h5M8 21v-5H3m18 0h-5v5\"/></svg>"};let marker=null,overflow='',timer,wasNative=false;const stamp=n=>{n=Math.max(0,Math.floor(n||0));return Math.floor(n/60)+':'+String(n%60).padStart(2,'0')};function reveal(){p.classList.remove('mgm-hide');clearTimeout(timer);if(!v.paused)timer=setTimeout(()=>p.classList.add('mgm-hide'),3000)}function sync(){toggles.forEach(b=>{b.innerHTML=v.paused?icons.play:icons.pause;b.setAttribute('aria-label',v.paused?'再生':'一時停止')});mute.innerHTML=v.muted?icons.mute:icons.sound;mute.setAttribute('aria-label',v.muted?'音を出す':'消音');mute.setAttribute('aria-pressed',String(v.muted));if(Number.isFinite(v.duration)){seek.max=v.duration;seek.value=v.currentTime;time.textContent=stamp(v.currentTime)+' / '+stamp(v.duration)}}function run(){message.textContent='';v.play().catch(()=>{message.textContent='再生ボタンを押してご覧ください。';sync();reveal()})}function fullState(){full.innerHTML=d.open?icons.exit:icons.full;full.setAttribute('aria-label',d.open?'全画面を閉じる':'全画面で見る');full.title=d.open?'全画面を閉じる':'全画面で見る';full.setAttribute('aria-expanded',String(d.open))}function close(){if(document.fullscreenElement===d&&document.exitFullscreen)document.exitFullscreen().catch(()=>{});d.close()}full.addEventListener('click',()=>{if(d.open){close();return}if(typeof d.showModal!=='function'){message.textContent='Safariで開いて全画面をご利用ください。';return}const playing=!v.paused;marker=document.createComment('MAGNUM player position');p.before(marker);overflow=document.body.style.overflow;stage.append(p);d.showModal();document.body.style.overflow='hidden';fullState();reveal();if(playing)run();if(d.requestFullscreen)d.requestFullscreen().then(()=>{wasNative=true}).catch(()=>{});});d.addEventListener('close',()=>{const playing=!v.paused;if(marker){marker.replaceWith(p);marker=null}document.body.style.overflow=overflow;fullState();reveal();if(playing)run();full.focus({preventScroll:true});wasNative=false});document.addEventListener('fullscreenchange',()=>{if(wasNative&&!document.fullscreenElement&&d.open)d.close()});toggles.forEach(b=>b.addEventListener('click',()=>{if(v.paused)run();else v.pause();reveal()}));mute.addEventListener('click',()=>{v.muted=!v.muted;sync();reveal()});seek.addEventListener('input',()=>{if(Number.isFinite(v.duration)){v.currentTime=Number(seek.value);sync();reveal()}});p.querySelectorAll('[data-mgm-skip]').forEach(b=>b.addEventListener('click',()=>{if(Number.isFinite(v.duration)){v.currentTime=Math.max(0,Math.min(v.duration,v.currentTime+Number(b.dataset.mgmSkip)));sync();reveal()}}));v.addEventListener('click',()=>{if(p.classList.contains('mgm-hide')||v.paused)reveal();else {p.classList.add('mgm-hide');clearTimeout(timer)}});p.addEventListener('pointermove',e=>{if(e.pointerType==='mouse')reveal()});p.addEventListener('focusin',reveal);['play','pause','ended'].forEach(e=>v.addEventListener(e,()=>{sync();reveal()}));['timeupdate','loadedmetadata','volumechange'].forEach(e=>v.addEventListener(e,sync));v.controls=false;p.classList.add('mgm-enhanced');sync();})();


(()=>{const root=document.getElementById('a5-magnum');if(!root||root.dataset.galleryReady)return;root.dataset.galleryReady='1';const main=root.querySelector('#mgm-actual-main'),thumbs=[...root.querySelectorAll('[data-mgm-photo-src]')],status=root.querySelector('#mgm-photo-status'),zoom=document.getElementById('mgm-photo-dialog'),zoomImage=zoom.querySelector('img'),mainButton=root.querySelector('.mgm-gallery-main');let full=thumbs[0].dataset.mgmPhotoFull,activeThumb=thumbs[0];thumbs.forEach(btn=>btn.addEventListener('click',()=>{main.removeAttribute('srcset');main.src=btn.dataset.mgmPhotoSrc;main.alt=btn.dataset.mgmPhotoAlt;full=btn.dataset.mgmPhotoFull;activeThumb=btn;thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b===btn)));status.textContent=btn.dataset.mgmPhotoIndex+' / '+thumbs.length+' — '+main.alt}));mainButton.addEventListener('click',()=>{zoomImage.src=full;zoomImage.alt=main.alt;if(typeof zoom.showModal==='function')zoom.showModal();else window.open(full,'_blank','noopener')});document.getElementById('mgm-photo-close').addEventListener('click',()=>zoom.close());zoom.addEventListener('close',()=>mainButton.focus({preventScroll:true}));root.querySelectorAll('[data-mgm-consult]').forEach(btn=>btn.addEventListener('click',()=>{const launcher=document.getElementById('A5ConsultLauncher');if(launcher){launcher.click()}else{location.href='/pages/contact'}}));})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a5-minotti-film"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFilms = (root) => {
      if (root.dataset.filmsReady === 'true') return;
      root.dataset.filmsReady = 'true';
      const videos = Array.from(root.querySelectorAll('video'));
      videos.forEach((video) => {
        video.addEventListener('play', () => {
          videos.forEach((other) => {
            if (other !== video && !other.paused) other.pause();
          });
        });
      });
      const dialog = root.querySelector('[data-a5-minotti-dialog]');
      const opener = root.querySelector('[data-a5-minotti-open-dialog]');
      const closer = root.querySelector('[data-a5-minotti-close-dialog]');
      if (dialog && opener) {
        opener.addEventListener('click', () => {
          if (typeof dialog.showModal === 'function') {
            videos.forEach((video) => video.pause());
            dialog.showModal();
          } else {
            const legacySource = dialog.querySelector('video source');
            if (legacySource) window.open(legacySource.src, '_blank', 'noopener');
          }
        });
        if (closer) closer.addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => {
          dialog.querySelectorAll('video').forEach((video) => video.pause());
        });
      }
      const candidates = Array.from(document.querySelectorAll('product-info[data-product-id]'));
      const productMain = candidates.find((candidate) => candidate.dataset.productId === root.dataset.productId);
      const actualTarget = productMain;
      if (actualTarget && actualTarget.id) {
        root.querySelectorAll('[data-a5-minotti-actual-link]').forEach((link) => {
          link.setAttribute('href', '#' + actualTarget.id);
        });
      }
    };
    document.querySelectorAll('[data-a5-minotti-films]').forEach(initializeFilms);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-a5-minotti-films]').forEach(initializeFilms);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bass-pro"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('a5-bass-product')){
  customElements.define('a5-bass-product',class extends HTMLElement{
    connectedCallback(){
      if(this.bassInitialized)return;
      this.bassInitialized=true;
      const video=this.querySelector('[data-bass-video]');
      const play=this.querySelector('[data-bass-play]');
      if(video&&play){
        video.muted=false;
        video.defaultMuted=false;
        video.loop=false;
        video.autoplay=false;
        play.addEventListener('click',()=>{
          video.muted=false;
          video.play().then(()=>{play.hidden=true;}).catch(()=>{play.hidden=false;});
        });
        video.addEventListener('play',()=>{play.hidden=true;});
        video.addEventListener('ended',()=>{play.hidden=false;});
      }
      const selector=this.querySelector('[data-bass-variant]');
      const add=this.querySelector('[data-bass-add]');
      const update=()=>{
        if(!selector)return;
        const option=selector.selectedOptions[0];
        if(!option)return;
        const d=option.dataset;
        const price=this.querySelector('[data-bass-price]');
        const compare=this.querySelector('[data-bass-compare]');
        const reference=this.querySelector('[data-bass-reference]');
        const highNote=this.querySelector('[data-bass-high-note]');
        if(price)price.textContent=d.price;
        if(compare)compare.textContent=d.compare;
        if(reference)reference.hidden=d.sale!=='true';
        const saving=this.querySelector('[data-bass-saving]');
        if(saving){saving.hidden=d.sale!=='true';saving.querySelector('[data-bass-percent]').textContent=d.percent+'%';saving.querySelector('[data-bass-saved]').textContent=d.saved;}
        if(highNote)highNote.hidden=d.high!=='true';
        if(add){
          const ready=this.dataset.purchaseReady==='true';
          add.disabled=!ready||d.available!=='true'||d.positive!=='true'||d.high==='true'||d.limit==='true';
          const label=add.querySelector('span');
          if(label)label.textContent=d.high==='true'?this.dataset.consultLabel:d.limit==='true'?this.dataset.limitLabel:d.available!=='true'?this.dataset.soldLabel:ready?this.dataset.addLabel:this.dataset.pendingLabel;
        }
      };
      if(selector){selector.addEventListener('change',update);update();}
      const form=this.querySelector('[data-bass-form]');
      if(form)form.addEventListener('submit',event=>{if(!add||add.disabled)event.preventDefault();});
      const links=Array.from(this.querySelectorAll('[data-bass-enlarge]'));
      const dialog=this.querySelector('[data-bass-dialog]');
      if(dialog&&typeof dialog.showModal==='function'){
        let active=0;
        let opener=null;
        const image=dialog.querySelector('[data-bass-dialog-image]');
        const caption=dialog.querySelector('[data-bass-dialog-caption]');
        const counter=dialog.querySelector('[data-bass-counter]');
        const show=index=>{
          active=(index+links.length)%links.length;
          const link=links[active];
          image.src=link.href;
          image.alt=link.dataset.caption||'';
          caption.textContent=link.dataset.caption||'';
          counter.textContent=(active+1)+' / '+links.length;
        };
        links.forEach((link,index)=>link.addEventListener('click',event=>{
          event.preventDefault();
          opener=link;
          show(index);
          dialog.showModal();
        }));
        dialog.querySelector('[data-bass-close]').addEventListener('click',()=>dialog.close());
        dialog.querySelector('[data-bass-prev]').addEventListener('click',()=>show(active-1));
        dialog.querySelector('[data-bass-next]').addEventListener('click',()=>show(active+1));
        dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
        dialog.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'){event.preventDefault();show(active-1);}if(event.key==='ArrowRight'){event.preventDefault();show(active+1);}});
        dialog.addEventListener('close',()=>{if(opener)opener.focus();});
      }
      if(!matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){
        this.classList.add('motion-ready');
        this.bassObserver=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');this.bassObserver.unobserve(entry.target);}});},{rootMargin:'0px 0px -20px 0px',threshold:.08});
        this.querySelectorAll('[data-bass-reveal]').forEach(item=>this.bassObserver.observe(item));
      }
    }
    disconnectedCallback(){if(this.bassObserver)this.bassObserver.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blueprint-pro"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('blueprint-product')) {

  customElements.define('blueprint-product', class extends HTMLElement {

    connectedCallback() { queueMicrotask(() => { if (this.isConnected) this.setup(); }); }

    setup() {

      if (this.bound) return;

      this.bound = true;

      this.onClick = this.handleClick.bind(this);

      this.onChange = this.handleChange.bind(this);

      this.onKey = this.handleKey.bind(this);

      this.onClose = this.handleClose.bind(this);

      this.onScroll = this.updateGallery.bind(this);

      this.addEventListener('click', this.onClick);

      this.addEventListener('change', this.onChange);

      this.addEventListener('keydown', this.onKey);

      this.dialog = this.querySelector('[data-bpr-dialog]');

      this.gallery = this.querySelector('[data-bpr-gallery]');

      this.photos = Array.from(this.querySelectorAll('[data-bpr-zoom]'));

      this.dialog?.addEventListener('close', this.onClose);

      this.gallery?.addEventListener('scroll', this.onScroll, { passive: true });

      this.updateGallery();

      this.setupMotion();

    }

    disconnectedCallback() {

      this.teardownMotion();

      this.removeEventListener('click', this.onClick);

      this.removeEventListener('change', this.onChange);

      this.removeEventListener('keydown', this.onKey);

      this.dialog?.removeEventListener('close', this.onClose);

      this.gallery?.removeEventListener('scroll', this.onScroll);

      this.zoomToken = (this.zoomToken || 0) + 1;

      this.bound = false;

    }

    setupMotion() {

      if (this.layerBound) return;

      this.layerStory = this.querySelector('[data-bpr-layer-story]');

      this.layerStage = this.querySelector('[data-bpr-layer-stage]');

      this.layerFrames = Array.from(this.querySelectorAll('[data-bpr-layer-frame]')).sort((a, b) => Number(a.dataset.frame) - Number(b.dataset.frame));

      this.layerSteps = Array.from(this.querySelectorAll('[data-bpr-layer-step]')).sort((a, b) => Number(a.dataset.step) - Number(b.dataset.step));

      this.layerFallbacks = Array.from(this.querySelectorAll('[data-bpr-layer-fallback]'));

      this.layerCounters = Array.from(this.querySelectorAll('[data-bpr-layer-index]'));

      this.layerLinks = Array.from(this.querySelectorAll('[data-bpr-scene]'));

      this.layerImages = this.layerFrames.map(frame => frame.querySelector('img'));

      this.layerValid = Boolean(this.layerStory && this.layerStage && this.layerFrames.length === 5 && this.layerSteps.length === 5 &&

        this.layerFrames.every((frame, index) => Number(frame.dataset.frame) === index && this.layerImages[index]) &&

        this.layerSteps.every((step, index) => Number(step.dataset.step) === index));

      if (!this.layerValid || !window.matchMedia || !window.requestAnimationFrame) return;

      this.layerBound = true;

      this.layerPreference = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.layerFallbackAria = new Map(this.layerFallbacks.map(node => [node, node.getAttribute('aria-hidden')]));

      this.layerFrame = 0;

      this.layerActive = -1;

      this.layerDirty = true;

      this.layerNear = true;

      this.layerHashIndex = null;

      this.onLayerScroll = () => this.scheduleLayerMotion();

      this.onLayerResize = () => { this.layerDirty = true; this.scheduleLayerMotion(); };

      this.onLayerPreference = () => {

        if (this.layerPreference.matches) this.resetLayerMotion('reduced');

        else { this.layerDirty = true; this.scheduleLayerMotion(); }

      };

      this.onLayerHash = () => {

        let hash = location.hash;

        try { hash = decodeURIComponent(hash); } catch (_) {}

        const index = this.layerSteps.findIndex(step => `#${step.id}` === hash);

        this.layerHashIndex = index >= 0 ? index : null;

        this.layerDirty = true;

        this.scheduleLayerMotion();

      };

      this.onLayerAsset = event => {

        if (!this.layerImages.includes(event.target)) return;

        if (event.type === 'error') this.resetLayerMotion('broken-image');

        this.layerDirty = true;

        this.scheduleLayerMotion();

      };

      this.layerPreference.addEventListener('change', this.onLayerPreference);

      window.addEventListener('scroll', this.onLayerScroll, { passive: true });

      window.addEventListener('resize', this.onLayerResize, { passive: true });

      window.addEventListener('pageshow', this.onLayerResize);

      window.addEventListener('hashchange', this.onLayerHash);

      this.addEventListener('load', this.onLayerAsset, true);

      this.addEventListener('error', this.onLayerAsset, true);

      if ('IntersectionObserver' in window) {

        this.layerObserver = new IntersectionObserver(entries => {

          this.layerNear = entries.some(entry => entry.isIntersecting);

          if (this.layerNear) this.scheduleLayerMotion();

        }, { rootMargin: '300px 0px' });

        this.layerObserver.observe(this.layerStory);

      }

      this.preloadLayerImages(0);

      this.onLayerHash();

    }

    teardownMotion() {

      if (!this.layerBound) return;

      this.resetLayerMotion('teardown');

      this.layerObserver?.disconnect();

      this.layerPreference?.removeEventListener('change', this.onLayerPreference);

      window.removeEventListener('scroll', this.onLayerScroll);

      window.removeEventListener('resize', this.onLayerResize);

      window.removeEventListener('pageshow', this.onLayerResize);

      window.removeEventListener('hashchange', this.onLayerHash);

      this.removeEventListener('load', this.onLayerAsset, true);

      this.removeEventListener('error', this.onLayerAsset, true);

      this.layerBound = false;

    }

    resetLayerMotion(reason) {

      if (this.layerFrame) cancelAnimationFrame(this.layerFrame);

      this.layerFrame = 0;

      this.layerEnabled = false;

      this.layerActive = -1;

      this.layerGeometry = null;

      this.layerStory?.classList.remove('is-layered');

      if (this.layerStory) {

        this.layerStory.dataset.layerState = reason || 'static';

        this.layerStory.removeAttribute('data-layer-pending');

        this.layerStory.removeAttribute('data-layer-index');

      }

      ['--bpr-layer-top', '--bpr-layer-height', '--bpr-layer-anchor'].forEach(name => this.layerStory?.style.removeProperty(name));

      if (this.layerStage) { this.layerStage.hidden = true; this.layerStage.setAttribute('aria-hidden', 'true'); }

      this.layerFrames?.forEach((frame, index) => {

        frame.hidden = index !== 0;

        frame.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');

      });

      this.layerFallbackAria?.forEach((original, node) => {

        original === null ? node.removeAttribute('aria-hidden') : node.setAttribute('aria-hidden', original);

      });

      this.layerSteps?.forEach(step => step.removeAttribute('data-layer-active'));

      this.layerLinks?.forEach(link => link.removeAttribute('aria-current'));

    }

    scheduleLayerMotion() {

      if (!this.layerBound || this.layerFrame || !this.isConnected || this.layerPreference.matches) return;

      this.layerFrame = requestAnimationFrame(() => {

        this.layerFrame = 0;

        if (this.isConnected && this.layerBound) this.updateLayerMotion();

      });

    }

    preloadLayerImages(index) {

      [index, Math.min(this.layerImages.length - 1, index + 1)].forEach(n => {

        const image = this.layerImages[n];

        if (image && image.loading !== 'eager') image.loading = 'eager';

      });

    }

    measureLayerMotion() {

      const viewport = window.innerHeight;

      const mobile = window.innerWidth < 900;

      const nav = this.querySelector('.bpr-nav');

      const top = (nav ? (parseFloat(getComputedStyle(nav).top) || 0) + nav.getBoundingClientRect().height : 0) + (mobile ? 8 : 24);

      const available = viewport - top - 24;

      const broken = this.layerImages.some(image => image.complete && image.naturalWidth === 0);

      if (this.layerPreference.matches || viewport < 600 || available < 300 || broken) {

        this.resetLayerMotion(broken ? 'broken-image' : this.layerPreference.matches ? 'reduced' : 'short-viewport');

        this.layerDirty = false;

        return false;

      }

      // Show the already-loaded first view before measuring the enhanced grid.

      // A pending initial image keeps the complete static source document visible.

      if (!this.layerEnabled && !(this.layerImages[0].complete && this.layerImages[0].naturalWidth > 0)) {

        this.preloadLayerImages(0);

        this.layerDirty = false;

        return false;

      }

      // All stage frames are initially hidden in source. Establish a ready

      // first view before enhancement, even if the requested chapter is pending.

      if (!this.layerEnabled) this.commitLayerFrame(0);

      this.layerStory.classList.add('is-layered');

      this.layerStage.hidden = false;

      const width = this.layerStage.getBoundingClientRect().width;

      if (!(width > 0)) {

        this.resetLayerMotion('unmeasurable-stage');

        this.layerDirty = false;

        return false;

      }

      const naturalHeight = width / (1376 / 768) + 96;

      const height = Math.min(available, naturalHeight, mobile ? viewport * .45 : available);

      if (height - 96 < 140 || (mobile && viewport - top - height < 200)) {

        this.resetLayerMotion('insufficient-reading-room');

        this.layerDirty = false;

        return false;

      }

      this.layerStory.style.setProperty('--bpr-layer-top', `${top}px`);

      this.layerStory.style.setProperty('--bpr-layer-height', `${height}px`);

      this.layerStory.style.setProperty('--bpr-layer-anchor', `${mobile ? top + height + 12 : top + 24}px`);

      this.layerGeometry = { top, height, mobile };

      this.layerEnabled = true;

      this.layerStory.dataset.layerState = 'layered';

      this.layerStage.setAttribute('aria-hidden', 'false');

      this.layerFallbacks.forEach(node => node.setAttribute('aria-hidden', 'true'));

      this.layerDirty = false;

      return true;

    }

    commitLayerFrame(index) {

      const image = this.layerImages[index];

      if (!(image?.complete && image.naturalWidth > 0)) return false;

      this.layerFrames.forEach((frame, n) => {

        frame.hidden = n !== index;

        frame.setAttribute('aria-hidden', n === index ? 'false' : 'true');

      });

      this.layerSteps.forEach((step, n) => n === index ? step.setAttribute('data-layer-active', 'true') : step.removeAttribute('data-layer-active'));

      this.layerLinks.forEach(link => {

        const hash = link.hash || link.getAttribute('href');

        const current = hash === `#${this.layerSteps[index].id}`;

        current ? link.setAttribute('aria-current', 'step') : link.removeAttribute('aria-current');

      });

      this.layerCounters.forEach(counter => { counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(this.layerFrames.length).padStart(2, '0')}`; });

      this.layerActive = index;

      this.layerStory.dataset.layerIndex = String(index);

      return true;

    }

    updateLayerMotion() {

      if (this.layerPreference.matches) { this.resetLayerMotion('reduced'); return; }

      if (!this.layerNear && !this.layerDirty) return;

      if (this.layerDirty && !this.measureLayerMotion()) return;

      if (!this.layerEnabled || !this.layerGeometry) return;

      const { top, height, mobile } = this.layerGeometry;

      const readingStart = mobile ? top + height + 12 : top;

      const readingLine = readingStart + (window.innerHeight - readingStart) * (mobile ? .35 : .45);

      const rects = this.layerSteps.map(step => step.getBoundingClientRect());

      let index = 0;

      rects.forEach((rect, n) => { if (rect.top <= readingLine) index = n; });

      // A native chapter hash should show its matching view immediately. Retain

      // it while that chapter occupies the reading area, without intercepting

      // the anchor, forcing focus, or synthesizing a scroll distance.

      if (this.layerHashIndex !== null) {

        const rect = rects[this.layerHashIndex];

        if (index <= this.layerHashIndex && rect.top <= readingLine && rect.bottom >= readingStart) index = this.layerHashIndex;

        else this.layerHashIndex = null;

      }

      this.preloadLayerImages(index);

      const image = this.layerImages[index];

      if (!(image.complete && image.naturalWidth > 0)) {

        this.layerStory.dataset.layerPending = String(index);

        return;

      }

      this.layerStory.removeAttribute('data-layer-pending');

      if (index === this.layerActive) return;

      this.commitLayerFrame(index);

    }

    selectMotionScene() {

      // Scene links remain ordinary native hash anchors.

    }



    updateGallery() {

      if (!this.gallery || !this.photos.length) return;

      const bounds = this.gallery.getBoundingClientRect();

      let index = 0;

      let distance = Infinity;

      this.photos.forEach((photo, n) => {

        const delta = Math.abs(photo.closest('figure').getBoundingClientRect().left - bounds.left);

        if (delta < distance) { index = n; distance = delta; }

      });

      this.galleryIndex = index;

      const counter = this.querySelector('[data-bpr-gallery-counter]');

      if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(this.photos.length).padStart(2, '0')}`;

      const previous = this.querySelector('[data-bpr-gallery-prev]');

      const next = this.querySelector('[data-bpr-gallery-next]');

      if (previous) previous.disabled = index === 0;

      if (next) next.disabled = index === this.photos.length - 1;

    }

    moveGallery(direction) {

      if (!this.gallery || !this.photos.length) return;

      const index = Math.max(0, Math.min(this.photos.length - 1, (this.galleryIndex || 0) + direction));

      const figure = this.photos[index].closest('figure');

      const distance = figure.getBoundingClientRect().left - this.gallery.getBoundingClientRect().left;

      this.gallery.scrollBy({ left: distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });

    }

    showPhoto(index) {

      if (!this.dialog?.showModal || !this.photos.length) return;

      this.photoIndex = (index + this.photos.length) % this.photos.length;

      const zoom = this.photos[this.photoIndex];

      const source = zoom.querySelector('img');

      const token = this.zoomToken = (this.zoomToken || 0) + 1;

      const image = new Image();

      image.src = source?.currentSrc || source?.src || zoom.href;

      image.alt = source?.alt || '';

      image.decoding = 'async';

      this.dialog.querySelector('[data-bpr-dialog-image]').replaceChildren(image);

      this.dialog.querySelector('[data-bpr-dialog-caption]').textContent = zoom.dataset.caption || '';

      if (!this.dialog.open) this.dialog.showModal();

      const large = new Image();

      large.decoding = 'async';

      large.onload = () => { if (this.zoomToken === token && image.isConnected) image.src = large.src; };

      large.src = zoom.href;

    }

    handleClose() {

      this.zoomToken = (this.zoomToken || 0) + 1;

      this.dialog.querySelector('[data-bpr-dialog-image]').replaceChildren();

      this.lastZoom?.focus({ preventScroll: true });

    }

    handleKey(event) {

      if (this.dialog?.open && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {

        event.preventDefault();

        this.showPhoto(this.photoIndex + (event.key === 'ArrowLeft' ? -1 : 1));

      } else if (event.target === this.gallery && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {

        event.preventDefault(); this.moveGallery(event.key === 'ArrowLeft' ? -1 : 1);

      }

    }

    handleClick(event) {

      this.selectMotionScene(event);

      const zoom = event.target.closest('[data-bpr-zoom]');

      if (zoom && this.contains(zoom) && this.dialog?.showModal) {

        event.preventDefault(); this.lastZoom = zoom; this.showPhoto(this.photos.indexOf(zoom));

      }

      if (event.target.closest('[data-bpr-gallery-prev]')) this.moveGallery(-1);

      if (event.target.closest('[data-bpr-gallery-next]')) this.moveGallery(1);

      if (event.target.closest('[data-bpr-dialog-prev]')) this.showPhoto(this.photoIndex - 1);

      if (event.target.closest('[data-bpr-dialog-next]')) this.showPhoto(this.photoIndex + 1);

      const consultation = event.target.closest('[data-bpr-consult]');

      if (consultation && this.contains(consultation) && this.dataset.preview !== 'true') {

        const launcher = document.getElementById('A5ConsultLauncher');

        if (launcher && launcher !== consultation) { event.preventDefault(); launcher.click(); }

      }

      if (event.target === this.dialog) {

        const box = this.dialog.getBoundingClientRect();

        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();

      }

    }

    handleChange(event) {

      if (!event.target.matches('[data-bpr-variant]')) return;

      const option = event.target.selectedOptions[0]; if (!option) return;

      const data = option.dataset;

      this.querySelectorAll('[data-bpr-price]').forEach(node => node.textContent = data.price);

      this.querySelectorAll('[data-bpr-coord-total]').forEach(node => node.textContent = data.coordinationTotal);

      this.querySelectorAll('[data-bpr-compare]').forEach(node => node.textContent = data.compare);

      this.querySelectorAll('[data-bpr-saving]').forEach(node => node.textContent = data.saving);

      this.querySelectorAll('[data-bpr-discount]').forEach(node => node.textContent = data.discount);

      this.querySelectorAll('[data-bpr-compare-wrap],[data-bpr-saving-wrap]').forEach(node => node.hidden = data.onSale !== 'true');

      const input = this.querySelector('[data-bpr-quantity]');

      const minimum = Number(data.min || 1); const maximum = data.max === '' ? null : Number(data.max);

      if (input) { input.min = String(minimum); input.step = data.step || '1'; input.value = String(minimum); maximum === null ? input.removeAttribute('max') : input.setAttribute('max', String(maximum)); }

      const available = data.available === 'true'; const highValue = data.highValue === 'true';

      const quantityAllowed = maximum === null || maximum >= minimum;

      const purchaseEnabled = this.dataset.purchaseEnabled === 'true' && this.dataset.preview !== 'true';

      const enabled = available && quantityAllowed && purchaseEnabled && !highValue;

      const add = this.querySelector('[data-bpr-add]');

      if (add) { add.disabled = !enabled; add.textContent = enabled ? this.dataset.addLabel : !available ? this.dataset.soldOutLabel : highValue || !purchaseEnabled ? this.dataset.consultLabel : this.dataset.quantityLabel; }

      const payment = this.querySelector('[data-bpr-payment]'); if (payment) payment.hidden = !enabled;

      const count = this.querySelector('[data-bpr-cart-count]'); if (count) { count.hidden = Number(data.cart) === 0; this.querySelector('[data-bpr-cart-number]').textContent = data.cart; }

      const status = this.querySelector('[data-bpr-form-status]'); if (status) status.textContent = highValue ? this.dataset.highValueNote : '';

      if (this.dataset.preview !== 'true') { const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState(history.state, '', url); }

    }

  });

}






  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloud-pro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('a5-cloud-product')) {
  customElements.define('a5-cloud-product', class extends HTMLElement {
    connectedCallback() {
      if (this._cloudStarted) return;
      this._cloudStarted = true;
      this._events = new AbortController();
      this._signal = this._events.signal;
      this._frame = 0;
      this._resizeFrame = 0;
      this.setupGallery();
      this.setupProduct();
      this.setupStory();
    }
    disconnectedCallback() {
      this._events?.abort();
      this._resizeObserver?.disconnect();
      this._motion?.removeEventListener('change', this._onStoryResize);
      cancelAnimationFrame(this._frame);
      cancelAnimationFrame(this._resizeFrame);
      if (this._dialog?.open) this._dialog.close();
      this._cloudStarted = false;
    }
    setupStory() {
      this._story = this.querySelector('[data-cld-story]');
      this._stage = this.querySelector('[data-cld-stage]');
      this._picture = this.querySelector('[data-cld-picture]');
      this._steps = [...this.querySelectorAll('[data-cld-step]')];
      this._jumps = [...this.querySelectorAll('[data-cld-jump]')];
      this._motion = matchMedia('(prefers-reduced-motion: reduce)');
      this._frames = [];
      this._picture.replaceChildren();
      this._mediaFailed = false;
      this._active = -1;
      if (!this._steps.length || !this._steps.every(step => step.querySelector('[data-cld-fallback] img'))) return;
      this._steps.forEach((step, index) => {
        const frame = step.querySelector('[data-cld-fallback]').cloneNode(true);
        frame.removeAttribute('data-cld-fallback');
        frame.className = 'cld-frame';
        frame.hidden = true;
        frame.removeAttribute('aria-hidden');
        const img = frame.querySelector('img');
        img.loading = 'eager';
        img.addEventListener('load', () => this.resizeStory(), { signal: this._signal });
        img.addEventListener('error', () => { this._mediaFailed = true; this.disableStory(); }, { signal: this._signal });
        this._picture.append(frame);
        this._frames[index] = frame;
      });
      this._onStoryResize = () => {
        cancelAnimationFrame(this._resizeFrame);
        this._resizeFrame = requestAnimationFrame(() => this.resizeStory());
      };
      this._motion.addEventListener('change', this._onStoryResize);
      window.addEventListener('resize', this._onStoryResize, { passive: true, signal: this._signal });
      window.addEventListener('scroll', () => this.queueStoryUpdate(), { passive: true, signal: this._signal });
      this._resizeObserver = new ResizeObserver(this._onStoryResize);
      this._resizeObserver.observe(this.querySelector('.cld-nav'));
      this.resizeStory();
    }
    disableStory() {
      this._story?.classList.remove('is-layered');
      this._steps?.forEach(step => step.querySelector('[data-cld-fallback]')?.removeAttribute('aria-hidden'));
    }
    resizeStory() {
      if (!this.isConnected || !this._frames?.length || this._mediaFailed) return;
      if (this._motion.matches || window.innerHeight < 660) { this.disableStory(); return; }
      this._story.classList.add('is-layered');
      const configured = parseFloat(getComputedStyle(this).getPropertyValue('--cld-config-top')) || 0;
      let headerBottom = configured;
      document.querySelectorAll('sticky-header,[data-header-sticky],#shopify-section-header,.section-header,.header-wrapper').forEach(node => {
        if (this.contains(node)) return;
        const css = getComputedStyle(node);
        const rect = node.getBoundingClientRect();
        if ((css.position === 'sticky' || css.position === 'fixed') && rect.top <= configured + 3 && rect.bottom > 0 && rect.height < 180) headerBottom = Math.max(headerBottom, rect.bottom);
      });
      this.style.setProperty('--cld-head-top', `${Math.max(0, Math.round(headerBottom))}px`);
      const navHeight = this.querySelector('.cld-nav').getBoundingClientRect().height;
      this._stageTop = Math.max(0, headerBottom) + navHeight + (window.innerWidth >= 900 ? 16 : 0);
      this.style.setProperty('--cld-stage-top', `${Math.round(this._stageTop)}px`);
      const pictureHeight = Math.min(this._stage.clientWidth * 768 / 1376, window.innerHeight * .49);
      this.style.setProperty('--cld-picture-h', `${Math.floor(pictureHeight)}px`);
      this.style.setProperty('--cld-stage-total', `${Math.ceil(this._stage.getBoundingClientRect().height)}px`);
      this._steps.forEach(step => step.querySelector('[data-cld-fallback]').setAttribute('aria-hidden', 'true'));
      this.updateStory();
    }
    queueStoryUpdate() {
      if (this._frame || !this.isConnected) return;
      this._frame = requestAnimationFrame(() => { this._frame = 0; this.updateStory(); });
    }
    updateStory() {
      if (!this._story?.classList.contains('is-layered')) return;
      const mobile = window.innerWidth < 900;
      const readLine = mobile ? this._stageTop + this._stage.getBoundingClientRect().height + 64 : Math.max(this._stageTop + 40, window.innerHeight * .43);
      let next = 0;
      this._steps.forEach((step, index) => { if (step.getBoundingClientRect().top <= readLine) next = index; });
      const img = this._frames[next]?.querySelector('img');
      if (!img?.complete || !img.naturalWidth) {
        if (this._active < 0) this.disableStory();
        return;
      }
      if (next === this._active) return;
      this._frames.forEach((frame, index) => { frame.hidden = index !== next; });
      this._jumps.forEach((jump, index) => { if (index === next) jump.setAttribute('aria-current', 'step'); else jump.removeAttribute('aria-current'); });
      this.querySelector('[data-cld-index]').textContent = `${String(next + 1).padStart(2, '0')} / 04`;
      this._active = next;
    }
    setupGallery() {
      this._gallery = this.querySelector('[data-cld-gallery]');
      this._zooms = [...this.querySelectorAll('[data-cld-zoom]')];
      this._dialog = this.querySelector('[data-cld-dialog]');
      if (!this._dialog || typeof this._dialog.showModal !== 'function') return;
      this._zooms.forEach((link, index) => link.addEventListener('click', event => {
        event.preventDefault(); this._returnFocus = link; this.showPhoto(index); this._dialog.showModal(); this._dialog.querySelector('[data-cld-close]').focus();
      }, { signal: this._signal }));
      this._dialog.querySelector('[data-cld-close]').addEventListener('click', () => this._dialog.close(), { signal: this._signal });
      this._dialog.querySelector('[data-cld-previous]').addEventListener('click', () => this.showPhoto(this._photoIndex - 1), { signal: this._signal });
      this._dialog.querySelector('[data-cld-next]').addEventListener('click', () => this.showPhoto(this._photoIndex + 1), { signal: this._signal });
      this._dialog.addEventListener('keydown', event => { if (event.key === 'ArrowLeft') { event.preventDefault(); this.showPhoto(this._photoIndex - 1); } if (event.key === 'ArrowRight') { event.preventDefault(); this.showPhoto(this._photoIndex + 1); } }, { signal: this._signal });
      this._dialog.addEventListener('close', () => { if (this._returnFocus?.isConnected) this._returnFocus.focus(); }, { signal: this._signal });
      this._gallery?.addEventListener('keydown', event => { if (event.target !== this._gallery) return; if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this._gallery.scrollBy({ left: this._gallery.clientWidth * (event.key === 'ArrowRight' ? 1 : -1), behavior: this._motion?.matches ? 'auto' : 'smooth' }); } }, { signal: this._signal });
    }
    showPhoto(index) {
      if (index < 0 || index >= this._zooms.length) return;
      this._photoIndex = index;
      const link = this._zooms[index], original = link.querySelector('img'), img = this._dialog.querySelector('[data-cld-dialog-image]');
      img.src = link.href; img.alt = original.alt;
      this._dialog.querySelector('[data-cld-dialog-caption]').textContent = link.closest('figure').querySelector('figcaption').textContent.trim();
      this._dialog.querySelector('[data-cld-dialog-count]').textContent = `${index + 1} / ${this._zooms.length}`;
      this._dialog.querySelector('[data-cld-previous]').disabled = index === 0;
      this._dialog.querySelector('[data-cld-next]').disabled = index === this._zooms.length - 1;
    }
    setupProduct() {
      this._selector = this.querySelector('[data-cld-variant]');
      if (!this._selector) return;
      this._selector.addEventListener('change', () => this.updateProduct(), { signal: this._signal });
      this.updateProduct(false);
    }
    updateProduct(updateURL = true) {
      const option = this._selector.selectedOptions[0];
      if (!option) return;
      const data = option.dataset, quantity = this.querySelector('[data-cld-quantity]'), add = this.querySelector('[data-cld-add]');
      const min = Number(data.min) || 1, step = Number(data.step) || 1, max = data.max === '' ? null : Number(data.max);
      quantity.min = min; quantity.step = step;
      if (max === null) quantity.removeAttribute('max'); else quantity.max = max;
      if (!quantity.value || Number(quantity.value) < min || max !== null && Number(quantity.value) > max) quantity.value = min;
      const available = data.available === 'true', high = data.high === 'true', positive = data.positive === 'true';
      const allowed = available && !high && positive && this.dataset.cldReady === 'true' && this.dataset.cldSaleReady === 'true' && (max === null || max >= min);
      add.disabled = !allowed;
      add.textContent = high ? this.dataset.consultLabel : !available ? this.dataset.soldLabel : allowed ? this.dataset.addLabel : this.dataset.limitLabel;
      this.querySelectorAll('[data-cld-price]').forEach(node => { node.textContent = positive ? data.price : this.dataset.pendingLabel; });
      this.querySelectorAll('.cld-price small').forEach(node => { node.hidden = !positive; });
      this.querySelectorAll('[data-cld-compare]').forEach(node => { node.textContent = data.compare; });
      this.querySelectorAll('[data-cld-saving]').forEach(node => { node.textContent = data.saving; });
      this.querySelectorAll('[data-cld-percent]').forEach(node => { node.textContent = data.percent; });
      this.querySelectorAll('[data-cld-reference],[data-cld-saving-wrap]').forEach(node => { node.hidden = data.sale !== 'true' || !positive; });
      this.querySelector('[data-cld-high-note]').hidden = !high;
      this.querySelector('[data-cld-cart-count]').textContent = data.cart;
      this.querySelector('[data-cld-cart-note]').hidden = Number(data.cart) === 0;
      const payment = this.querySelector('[data-cld-payment]'); if (payment) payment.hidden = !allowed;
      if (updateURL) { const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url); }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hampton-pro"] && !Shopify.designMode) return;
  try {
    
(() => {
  const active = new Map();
  const init = (root) => {
    if (active.has(root)) return;
    const abort = new AbortController();
    const signal = abort.signal;
    const labels = JSON.parse(root.querySelector('[data-hp-labels]').textContent);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const scenes = [...root.querySelectorAll('[data-hp-scene]')];
    const sceneButtons = [...root.querySelectorAll('[data-hp-select-scene]')];
    let activeScene = 'day';
    let manualScene = false;
    let sceneEpoch = 0;
    const selectScene = (name) => {
      const selected = scenes.find((scene) => scene.dataset.hpScene === name);
      if (!selected || name === activeScene && root.querySelector('.hp-pro__scenes').hasAttribute('data-enhanced')) return;
      const update = () => {
        activeScene = name;
        scenes.forEach((scene) => { scene.hidden = scene !== selected; });
        sceneButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.hpSelectScene === name)));
      };
      const image = selected.querySelector('img');
      const epoch = ++sceneEpoch;
      if (image && image.loading === 'lazy') image.loading = 'eager';
      const ready = image && image.decode ? image.decode().catch(() => {}) : Promise.resolve();
      ready.then(() => {
        if (epoch !== sceneEpoch || signal.aborted) return;
        update();
        if (!reduce.matches && selected.animate) selected.animate([{ opacity: 0.45 }, { opacity: 1 }], { duration: 550, easing: 'ease-out' });
      });
    };
    if (scenes.length === 2 && sceneButtons.length === 2) {
      root.querySelector('.hp-pro__scenes').dataset.enhanced = 'true';
      scenes[1].hidden = true;
      root.querySelector('.hp-pro__scene-controls').hidden = false;
      sceneButtons.forEach((button) => button.addEventListener('click', () => { manualScene = true; selectScene(button.dataset.hpSelectScene); }, { signal }));
    }
    const select = root.querySelector('[data-hp-variant]');
    const quantity = root.querySelector('[data-hp-quantity]');
    const submit = root.querySelector('[data-hp-submit]');
    const form = root.querySelector('.hp-pro__product-form');
    const updateVariant = () => {
      const option = select.options[select.selectedIndex];
      if (!option) { submit.disabled = true; return; }
      const price = Number(option.dataset.price);
      const available = option.dataset.available === 'true';
      const hasPrice = price > 0;
      root.querySelector('[data-hp-price]').textContent = hasPrice ? option.dataset.priceText : labels.askPrice;
      root.querySelectorAll('[data-hp-price-echo]').forEach((node) => { node.textContent = hasPrice ? option.dataset.priceText : labels.askPrice; });
      const reference = Number(root.dataset.hpReference);
      const difference = Math.max(0, reference - price);
      const reduction = Math.round(difference / reference * 100);
      root.querySelectorAll('[data-hp-reduction]').forEach((node) => { node.hidden = !hasPrice || difference <= 0; node.textContent = `${reduction}% OFF`; });
      const saving = root.querySelector('[data-hp-saving]');
      if (saving) {
        saving.hidden = !hasPrice || difference <= 0;
        if (hasPrice) root.querySelector('[data-hp-saving-value]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'ja-JP', { style: 'currency', currency: root.dataset.hpCurrency || 'JPY', maximumFractionDigits: 0 }).format(difference / 100);
      }
      const compare = root.querySelector('[data-hp-compare]');
      if (compare) { compare.hidden = !hasPrice || Number(option.dataset.compare) <= price; const compareValue = root.querySelector('[data-hp-compare-value]'); if (compareValue) compareValue.textContent = option.dataset.compareText; }
      const tax = root.querySelector('[data-hp-tax]');
      if (tax) tax.hidden = !hasPrice;
      root.querySelector('[data-hp-stock]').textContent = !hasPrice ? labels.pending : available ? labels.available : labels.unavailable;
      submit.disabled = !hasPrice || !available;
      submit.textContent = !hasPrice ? labels.askPrice : available ? labels.add : labels.unavailableShort;
      const min = Math.max(1, Number(option.dataset.quantityMin) || 1);
      const step = Math.max(1, Number(option.dataset.quantityStep) || 1);
      const max = Number(option.dataset.quantityMax);
      quantity.min = String(min);
      quantity.step = String(step);
      if (max > 0) quantity.max = String(max); else quantity.removeAttribute('max');
      quantity.value = String(min);
    };
    select.addEventListener('change', () => {
      updateVariant();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState(window.history.state, '', url);
    }, { signal });
    form.addEventListener('submit', (event) => {
      const option = select.options[select.selectedIndex];
      if (!option || Number(option.dataset.price) <= 0 || option.dataset.available !== 'true') event.preventDefault();
    }, { signal });
    const dialog = root.querySelector('.hp-pro__dialog');
    const zoomImage = root.querySelector('[data-hp-zoom-image]');
    let zoomOpener = null;
    if (dialog && typeof dialog.showModal === 'function') {
      root.querySelectorAll('[data-hp-zoom]').forEach((link) => link.addEventListener('click', (event) => {
        event.preventDefault();
        zoomOpener = link;
        zoomImage.src = link.href;
        zoomImage.alt = link.querySelector('img').alt;
        dialog.showModal();
      }, { signal }));
      root.querySelector('[data-hp-close]').addEventListener('click', () => dialog.close(), { signal });
      dialog.addEventListener('close', () => { zoomOpener?.focus({ preventScroll: true }); }, { signal });
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); }, { signal });
    }
    const gallery = root.querySelector('.hp-pro__gallery');
    const photoLinks = [...root.querySelectorAll('[data-hp-photo-index]')];
    const photos = [...root.querySelectorAll('.hp-pro__gallery-item')];
    photoLinks.forEach((link) => link.addEventListener('click', (event) => {
      const photo = photos[Number(link.dataset.hpPhotoIndex)];
      if (!photo || !gallery) return;
      event.preventDefault();
      gallery.scrollTo({ left: photo.offsetLeft - photos[0].offsetLeft, behavior: reduce.matches ? 'auto' : 'smooth' });
      photoLinks.forEach((item) => item.setAttribute('aria-current', String(item === link)));
    }, { signal }));
    let galleryObserver = null;
    if (gallery && 'IntersectionObserver' in window) {
      galleryObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio < 0.6) return;
          const index = photos.indexOf(entry.target);
          photoLinks.forEach((item, position) => item.setAttribute('aria-current', String(position === index)));
        });
      }, { root: gallery, threshold: [0.6] });
      photos.forEach((photo) => galleryObserver.observe(photo));
    }
    root.querySelectorAll('[data-hp-buy]').forEach((link) => link.addEventListener('click', () => root.querySelector('video')?.pause(), { signal }));
    const motion = [...root.querySelectorAll('[data-hp-parallax]')];
    const roomCues = [...root.querySelectorAll('[data-hp-room-cue]')];
    const desktop = window.matchMedia('(min-width: 1000px)');
    let frame = 0;
    let lastSceneCue = '';
    const paint = () => {
      frame = 0;
      const viewport = document.documentElement.clientHeight;
      const rootRect = root.getBoundingClientRect();
      const span = Math.max(1, rootRect.height - viewport);
      root.style.setProperty('--hp-progress', String(Math.max(0, Math.min(1, -rootRect.top / span))));
      motion.forEach((item) => {
        if (reduce.matches) { item.style.removeProperty('--hp-y'); return; }
        const rect = item.getBoundingClientRect();
        if (rect.bottom < -30 || rect.top > viewport + 30) return;
        const offset = Math.max(-18, Math.min(18, ((viewport / 2 - rect.top - rect.height / 2) / (viewport + rect.height)) * 65));
        item.style.setProperty('--hp-y', `${offset.toFixed(2)}px`);
      });
      if (desktop.matches && !reduce.matches && roomCues.length === 2 && scenes.length === 2) {
        const cue = roomCues.reduce((closest, item) => Math.abs(item.getBoundingClientRect().top + item.offsetHeight / 2 - viewport / 2) < Math.abs(closest.getBoundingClientRect().top + closest.offsetHeight / 2 - viewport / 2) ? item : closest);
        const cueRect = cue.getBoundingClientRect();
        const name = cue.dataset.hpRoomCue;
        if (cueRect.bottom > 0 && cueRect.top < viewport && name !== lastSceneCue) {
          lastSceneCue = name;
          if (!manualScene) selectScene(name);
        }
      }
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(paint); };
    window.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', schedule, { passive: true, signal });
    reduce.addEventListener('change', schedule, { signal });
    schedule();
    active.set(root, () => { abort.abort(); cancelAnimationFrame(frame); galleryObserver?.disconnect(); });
  };
  const scan = (scope) => {
    if (scope.matches?.('[data-hampton-section]')) init(scope);
    scope.querySelectorAll('[data-hampton-section]').forEach(init);
  };
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    active.forEach((cleanup, root) => { if (event.target.contains(root)) { cleanup(); active.delete(root); } });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horm-mattress-compare"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('horm-mattress-compare')) {
  customElements.define('horm-mattress-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.sizePanels = [...this.querySelectorAll('[data-hmc-size-panel]')];
      this.sizeButtons = [...this.querySelectorAll('[data-hmc-size]')];
      this.viewButtons = [...this.querySelectorAll('[data-hmc-view]')];
      this.rows = [...this.querySelectorAll('[data-hmc-table-row]')];
      this.status = this.querySelector('[data-hmc-live-status]');
      if (this.sizePanels.length !== 4 || this.sizeButtons.length !== 4 || this.viewButtons.length !== 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.currentSize = this.dataset.defaultSize || '160x200';
      this.currentView = this.dataset.defaultView || 'top';
      this.requestedSize = this.currentSize;
      this.requestedView = this.currentView;
      this.addEventListener('click', event => {
        const sizeButton = event.target.closest('button[data-hmc-size]');
        const viewButton = event.target.closest('button[data-hmc-view]');
        if (sizeButton && this.contains(sizeButton)) this.select(sizeButton.dataset.hmcSize, this.requestedView);
        if (viewButton && this.contains(viewButton)) this.select(this.requestedSize, viewButton.dataset.hmcView);
      }, options);
      this.querySelectorAll('[data-hmc-view-panel]').forEach(figure => {
        const image = figure.querySelector('img');
        const error = figure.querySelector('[data-hmc-image-error]');
        if (!image || !error) return;
        const updateError = () => { error.hidden = !(image.complete && image.naturalWidth === 0); };
        image.addEventListener('error', updateError, options);
        image.addEventListener('load', updateError, options);
        updateError();
      });
      this.commit(this.currentSize, this.currentView, false);
      const controls = this.querySelector('[data-hmc-controls]');
      if (controls) controls.hidden = false;
      this.dataset.enhanced = 'true';
    }

    select(size, view) {
      if (size === this.requestedSize && view === this.requestedView) return;
      if (!this.sizePanels.some(panel => panel.dataset.hmcSizePanel === size)) return;
      if (!this.viewButtons.some(button => button.dataset.hmcView === view)) return;
      this.requestedSize = size;
      this.requestedView = view;
      const token = this.selectionToken = (this.selectionToken || 0) + 1;
      if (this.transition) this.transition.skipTransition();
      const update = () => { if (this.isConnected && this.selectionToken === token) this.commit(size, view, true); };
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (document.startViewTransition && !reducedMotion) {
        const transition = document.startViewTransition(update);
        this.transition = transition;
        transition.finished.catch(() => {}).finally(() => { if (this.transition === transition) this.transition = null; });
      } else {
        update();
      }
    }

    commit(size, view, announce) {
      this.currentSize = size;
      this.currentView = view;
      this.sizePanels.forEach(panel => {
        panel.hidden = panel.dataset.hmcSizePanel !== size;
        panel.querySelectorAll('[data-hmc-view-panel]').forEach(figure => {
          figure.hidden = figure.dataset.hmcViewPanel !== view;
          if (!panel.hidden && !figure.hidden && announce && this.status) this.status.textContent = figure.dataset.hmcAnnouncement;
        });
      });
      this.sizeButtons.forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.hmcSize === size)); });
      this.viewButtons.forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.hmcView === view)); });
      this.rows.forEach(row => { row.dataset.selected = String(row.dataset.hmcTableRow === size); });
    }

    disconnectedCallback() {
      this.selectionToken = (this.selectionToken || 0) + 1;
      if (this.transition) this.transition.skipTransition();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["idv_story"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const scenes = root.querySelector('[data-idv-scenes]');
    const chapters = Array.from(scenes.querySelectorAll('[data-idv-chapter]'));
    const dots = Array.from(scenes.querySelectorAll('.idv-scene-dots i'));
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const touch = matchMedia('(hover: none) and (pointer: coarse)');
    const clamp = n => Math.max(0, Math.min(1, n));
    const smooth = n => n * n * (3 - 2 * n);
    let queued = false, enabled = false, nearby = true, distance = 1, width = innerWidth, timer;
    const probe = document.createElement('div');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'position:absolute;width:0;height:100vh;height:100svh;visibility:hidden;pointer-events:none;overflow:hidden';
    root.append(probe);
    function paint() {
      queued = false;
      if (!enabled) return;
      const progress = clamp(-scenes.getBoundingClientRect().top / distance);
      const blend = smooth(clamp((progress - .32) / .36));
      chapters.forEach((chapter, index) => {
        const local = index ? progress - .75 : progress - .25;
        chapter.style.setProperty('--idv-alpha', String(index ? blend : 1 - blend));
        chapter.style.setProperty('--idv-image-y', (local * (width < 900 ? 28 : 64)).toFixed(2) + 'px');
        chapter.style.setProperty('--idv-copy-y', (-local * (width < 900 ? 18 : 42)).toFixed(2) + 'px');
        chapter.style.setProperty('--idv-copy-alpha', String(index ? smooth(clamp((progress - .52) / .16)) : 1 - smooth(clamp((progress - .32) / .16))));
      });
      dots.forEach((dot, index) => dot.style.setProperty('--idv-dot', String(index ? blend : 1 - blend)));
    }
    function request() { if (!queued) { queued = true; requestAnimationFrame(paint); } }
    function configure() {
      width = innerWidth;
      const height = Math.floor(probe.getBoundingClientRect().height || innerHeight);
      const stage = Math.min(height, width < 900 ? 820 : 900);
      distance = Math.round(stage * .98);
      enabled = !reduced.matches && CSS.supports('position', 'sticky') && stage >= (width < 900 ? 680 : 540);
      root.style.setProperty('--idv-stage-height', stage + 'px');
      root.style.setProperty('--idv-distance', distance + 'px');
      scenes.classList.toggle('is-motion', enabled);
      if (!enabled) chapters.forEach(chapter => ['--idv-alpha', '--idv-image-y', '--idv-copy-y', '--idv-copy-alpha'].forEach(name => chapter.style.removeProperty(name)));
      request();
    }
    root.querySelectorAll('[data-idv-details]').forEach(link => { const info = document.querySelector('[id^="ProductInfo-"]'); if (info) link.href = '#' + info.id; });
    configure();
    if (typeof IntersectionObserver === 'function') new IntersectionObserver(entries => { nearby = entries[0].isIntersecting; request(); }, {rootMargin:'150px 0px'}).observe(scenes);
    addEventListener('scroll', () => { if (nearby) request(); }, {passive:true});
    addEventListener('resize', () => { if ((width < 900 || touch.matches) && Math.abs(innerWidth - width) < 2) return; clearTimeout(timer); timer = setTimeout(configure, 160); }, {passive:true});
    reduced.addEventListener('change', configure);
    const photos = Array.from(root.querySelectorAll('[data-idv-photo]'));
    const photoDialog = root.querySelector('[data-idv-photo-dialog]');
    const large = photoDialog.querySelector('[data-idv-photo-large]');
    const caption = photoDialog.querySelector('[data-idv-photo-caption]');
    let currentPhoto = 0, originPhoto = null, photoOverflow = '';
    function showPhoto(index) { currentPhoto = (index + photos.length) % photos.length; large.src = photos[currentPhoto].href; large.alt = photos[currentPhoto].dataset.caption; caption.textContent = large.alt; }
    photos.forEach((link,index) => link.addEventListener('click',event => { if (typeof photoDialog.showModal !== 'function') return; event.preventDefault(); originPhoto=link; showPhoto(index); photoOverflow=document.body.style.overflow; photoDialog.showModal(); document.body.style.overflow='hidden'; }));
    photoDialog.querySelector('[data-idv-photo-close]').addEventListener('click',()=>photoDialog.close());
    photoDialog.querySelector('[data-idv-photo-prev]').addEventListener('click',()=>showPhoto(currentPhoto-1));
    photoDialog.querySelector('[data-idv-photo-next]').addEventListener('click',()=>showPhoto(currentPhoto+1));
    photoDialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight')showPhoto(currentPhoto+1);if(event.key==='ArrowLeft')showPhoto(currentPhoto-1);});
    photoDialog.addEventListener('close',()=>{document.body.style.overflow=photoOverflow;if(originPhoto)originPhoto.focus({preventScroll:true});});
    const player=root.querySelector('[data-idv-player]'),video=root.querySelector('[data-idv-film]');
    const dialog=document.getElementById('idv-landscape-'+root.dataset.idvSection);
    if (!player || !video || !dialog) return;
    const stage=dialog.querySelector('.idv-landscape-stage'),toggles=player.querySelectorAll('[data-idv-toggle]'),mute=player.querySelector('[data-idv-mute]'),full=player.querySelector('[data-idv-full]'),seek=player.querySelector('input'),time=player.querySelector('output'),message=player.querySelector('.idv-player-message');
    const icon=path=>'<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'+path+'</svg>';
    const icons={play:icon('<path d="m8 5 11 7-11 7Z" fill="currentColor" stroke="none"/>'),pause:icon('<path d="M8 5v14M16 5v14" stroke-width="4"/>'),sound:icon('<path d="M11 4 6 8H3v8h3l5 4Zm4 4c3 2 3 6 0 8m3-11c5 4 5 10 0 14"/>'),mute:icon('<path d="M11 4 6 8H3v8h3l5 4Zm5 5 6 6m0-6-6 6"/>'),full:icon('<path d="M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5"/>'),exit:icon('<path d="M3 8h5V3m8 0v5h5M8 21v-5H3m18 0h-5v5"/>')};
    let marker=null,overflow='',hideTimer,nativeFull=false;
    const stamp=n=>{n=Math.max(0,Math.floor(n||0));return Math.floor(n/60)+':'+String(n%60).padStart(2,'0');};
    function reveal(){player.classList.remove('is-hidden');clearTimeout(hideTimer);if(!video.paused)hideTimer=setTimeout(()=>player.classList.add('is-hidden'),3000);}
    function sync(){toggles.forEach(button=>{button.innerHTML=video.paused?icons.play:icons.pause;button.setAttribute('aria-label',video.paused?root.dataset.play:root.dataset.pause);});mute.innerHTML=video.muted?icons.mute:icons.sound;mute.setAttribute('aria-label',video.muted?root.dataset.sound:root.dataset.mute);mute.setAttribute('aria-pressed',String(video.muted));if(Number.isFinite(video.duration)){seek.max=video.duration;seek.value=video.currentTime;time.textContent=stamp(video.currentTime)+' / '+stamp(video.duration);}}
    function run(){message.textContent='';video.play().catch(()=>{message.textContent=root.dataset.playAgain;sync();reveal();});}
    function fullState(){full.innerHTML=dialog.open?icons.exit:icons.full;full.setAttribute('aria-label',dialog.open?root.dataset.exit:root.dataset.full);full.setAttribute('aria-expanded',String(dialog.open));}
    full.addEventListener('click',()=>{if(dialog.open){if(document.fullscreenElement===dialog&&document.exitFullscreen)document.exitFullscreen().catch(()=>{});dialog.close();return;}if(typeof dialog.showModal!=='function'){if(video.webkitEnterFullscreen){video.webkitEnterFullscreen();return;}message.textContent=root.dataset.fullHelp;return;}const playing=!video.paused;marker=document.createComment('idv-player');player.before(marker);overflow=document.body.style.overflow;stage.append(player);dialog.showModal();document.body.style.overflow='hidden';fullState();reveal();if(playing)run();if(dialog.requestFullscreen)dialog.requestFullscreen().then(()=>{nativeFull=true;}).catch(()=>{});});
    dialog.addEventListener('close',()=>{const playing=!video.paused;if(marker){marker.replaceWith(player);marker=null;}document.body.style.overflow=overflow;fullState();reveal();if(playing)run();full.focus({preventScroll:true});nativeFull=false;});
    document.addEventListener('fullscreenchange',()=>{if(nativeFull&&!document.fullscreenElement&&dialog.open)dialog.close();});
    toggles.forEach(button=>button.addEventListener('click',()=>{if(video.paused)run();else video.pause();reveal();}));
    mute.addEventListener('click',()=>{video.muted=!video.muted;sync();reveal();});
    seek.addEventListener('input',()=>{if(Number.isFinite(video.duration)){video.currentTime=Number(seek.value);sync();reveal();}});
    player.querySelectorAll('[data-idv-skip]').forEach(button=>button.addEventListener('click',()=>{if(Number.isFinite(video.duration)){video.currentTime=Math.max(0,Math.min(video.duration,video.currentTime+Number(button.dataset.idvSkip)));sync();reveal();}}));
    video.addEventListener('click',()=>{if(player.classList.contains('is-hidden')||video.paused)reveal();else{player.classList.add('is-hidden');clearTimeout(hideTimer);}});
    player.addEventListener('pointermove',event=>{if(event.pointerType==='mouse')reveal();});player.addEventListener('focusin',reveal);
    ['play','pause','ended'].forEach(event=>video.addEventListener(event,()=>{sync();reveal();}));
    ['timeupdate','loadedmetadata','volumechange'].forEach(event=>video.addEventListener(event,sync));
    video.muted=false;video.defaultMuted=false;video.controls=false;player.classList.add('is-enhanced');sync();fullState();
  }
  document.querySelectorAll('[data-idv-root]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-idv-root]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mono-pro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('a5-mono-product')) {
  customElements.define('a5-mono-product', class extends HTMLElement {
    connectedCallback() {
      if (this.monoConnected) return;
      this.monoConnected = true;
      this.monoEvents = new AbortController();
      const on = (element, event, handler) => {
        if (element) element.addEventListener(event, handler, { signal: this.monoEvents.signal });
      };
      const video = this.querySelector('.mono-film');
      const play = this.querySelector('.mono-play');
      if (video) {
        video.muted = false;
        video.defaultMuted = false;
        video.autoplay = false;
        video.loop = false;
        if (play) play.hidden = false;
        on(play, 'click', () => {
          video.muted = false;
          if (video.ended) video.currentTime = 0;
          video.play().then(() => { if (play) play.hidden = true; }).catch(() => { if (play) play.hidden = false; });
        });
        on(video, 'play', () => { if (play) play.hidden = true; });
        on(video, 'ended', () => { if (play) play.hidden = false; });
      }
      const form = this.querySelector('.mono-product-form');
      const add = form && form.querySelector('[name="add"]');
      on(form, 'submit', (event) => {
        if (this.dataset.canAdd !== 'true' || !add || add.disabled) event.preventDefault();
      });
      const links = Array.from(this.querySelectorAll('.mono-gallery-link'));
      const dialog = this.querySelector('.mono-dialog');
      if (!dialog || typeof dialog.showModal !== 'function' || !links.length) return;
      const image = dialog.querySelector('.mono-dialog-image');
      const caption = dialog.querySelector('.mono-dialog-caption');
      const counter = dialog.querySelector('.mono-dialog-count');
      let position = 0;
      let opener = null;
      const show = (index) => {
        position = (index + links.length) % links.length;
        const link = links[position];
        image.src = link.href;
        image.alt = link.dataset.caption || '';
        caption.textContent = link.dataset.caption || '';
        counter.textContent = `${position + 1} / ${links.length}`;
      };
      links.forEach((link, index) => on(link, 'click', (event) => {
        event.preventDefault();
        opener = link;
        show(index);
        if (!dialog.open) dialog.showModal();
      }));
      on(dialog.querySelector('[data-gallery-close]'), 'click', () => dialog.close());
      on(dialog.querySelector('[data-gallery-prev]'), 'click', () => show(position - 1));
      on(dialog.querySelector('[data-gallery-next]'), 'click', () => show(position + 1));
      on(dialog, 'click', (event) => { if (event.target === dialog) dialog.close(); });
      on(dialog, 'keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(position - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); show(position + 1); }
      });
      on(dialog, 'close', () => { if (opener && opener.isConnected) opener.focus(); });
    }
    disconnectedCallback() {
      if (this.monoEvents) this.monoEvents.abort();
      const video = this.querySelector('.mono-film');
      if (video) video.pause();
      const dialog = this.querySelector('.mono-dialog');
      if (dialog && dialog.open) dialog.close();
      this.monoConnected = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-ec26-unison"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('unison-wide-head')) {
  customElements.define('unison-wide-head', class extends HTMLElement {
    connectedCallback() {
      if(this.dataset.ready)return;
      this.dataset.ready='true';
      const data=JSON.parse(this.querySelector('[data-uw-data]').textContent);
      const label=data.labels;
      const defaults={size:'D',view:'top',mattress:'RG',timber:'WN_oil',deck:'slats',side:'right'};
      const permitted={size:Object.keys(data.sizes),view:['top','oblique'],mattress:['RG','TT','BT'],timber:['WN_oil','WN_clear','BC_oil','BC_clear','RO_oil','RO_clear','ZK_oil','ZK_clear','RO_black'],deck:['slats','board'],side:['right','left']};
      const state={...defaults};
      const readUrl=()=>{const q=new URLSearchParams(location.search);Object.keys(defaults).forEach(k=>{state[k]=permitted[k].includes(q.get(k==='view'?'uw_view':k))?q.get(k==='view'?'uw_view':k):defaults[k];});};
      readUrl();
      const selected=()=>['MASTERWAL UNISON WIDE HEAD BED',label.new,`${state.size} / ${label[state.size]}`,label[state.mattress],label[state.timber],label[state.deck],label[state.side],`${label.head_width}: ${data.sizes[state.size].head} cm / ${label.depth}: 211.6 cm`,`${label.mattress_width}: ${data.sizes[state.size].mattress} cm / ${label.mattress_length}: 195 cm`,`${label.thickness}: ${data.thickness[state.mattress]} cm / ${label.head_height}: ${data.height[state.mattress]} cm`,label.pending].join('\n');
      const update=(write=true)=>{
        const size=data.sizes[state.size];
        this.querySelectorAll('[data-size]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.size===state.size)));
        this.querySelectorAll('[data-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.view===state.view)));
        this.querySelectorAll('[data-view-panel]').forEach(p=>{const active=p.dataset.viewPanel===state.view;p.hidden=false;p.dataset.active=String(active);p.inert=!active;p.setAttribute('aria-hidden',String(!active));});
        this.querySelectorAll('[data-choice]').forEach(s=>s.value=state[s.dataset.choice]);
        for(const [key,value] of Object.entries({...size,thickness:data.thickness[state.mattress],height:data.height[state.mattress]}))this.querySelectorAll(`[data-num="${key}"]`).forEach(e=>e.textContent=String(value));
        this.querySelector('[data-bar="head"]').setAttribute('width',size.head);
        this.querySelector('[data-bar="mattress"]').setAttribute('width',size.mattress);
        this.querySelector('[data-uw-summary]').textContent=[`${state.size} / ${label[state.size]}`,label[state.mattress],label[state.timber],label[state.deck],label[state.side]].join('\n');
        this.querySelector('[data-uw-form-summary]').value=selected();
        this.querySelector('[data-official]').href=`https://www.masterwal.jp/shop/g/gONLM-UNBD-${state.size}-WH/`;
        const url=new URL(location.href);if(['top','oblique'].includes(url.searchParams.get('view')))url.searchParams.delete('view');if(data.previewThemeId)url.searchParams.set('preview_theme_id',data.previewThemeId);Object.entries(state).forEach(([k,v])=>url.searchParams.set(k==='view'?'uw_view':k,v));
        this.querySelector('[data-uw-url]').value=url.href;
        this.querySelectorAll('[data-uw-anchor]').forEach(a=>{const target=new URL(url.href);target.hash=a.dataset.uwAnchor;a.href=target.href;});
        if(write)history.replaceState(null,'',url);
      };
      this.addEventListener('click',e=>{
        const anchor=e.target.closest('[data-uw-anchor]');
        if(anchor){const target=this.querySelector('#'+anchor.dataset.uwAnchor);if(target){e.preventDefault();e.stopPropagation();target.scrollIntoView({block:'start'});history.replaceState(null,'',anchor.href);}return;}
        const size=e.target.closest('[data-size]'),view=e.target.closest('[data-view]');
        if(size){state.size=size.dataset.size;update();}
        if(view){state.view=view.dataset.view;update();}
      });
      this.querySelectorAll('[data-choice]').forEach(s=>s.addEventListener('change',()=>{state[s.dataset.choice]=s.value;update();}));
      this.querySelector('[data-uw-copy]').addEventListener('click',async()=>{
        update();const field=this.querySelector('[data-uw-url]'),status=this.querySelector('[data-uw-status]');
        try{await navigator.clipboard.writeText(field.value);status.textContent=label.copied;}catch{field.hidden=false;field.focus();field.select();status.textContent=label.copy_failed;}
      });
      this.querySelector('[data-uw-download]').addEventListener('click',()=>{
        const url=URL.createObjectURL(new Blob([selected()+'\n\n'+this.querySelector('[data-uw-url]').value],{type:'text/plain;charset=utf-8'}));
        const a=document.createElement('a');a.href=url;a.download='MASTERWAL-UNISON-WIDE-HEAD-specification.txt';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
      });
      this._onPop=()=>{readUrl();update(false);};window.addEventListener('popstate',this._onPop);
      update(false);
    }
    disconnectedCallback(){if(this._onPop)window.removeEventListener('popstate',this._onPop);}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unison-wide-head"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('unison-wide-head')) {
  customElements.define('unison-wide-head', class extends HTMLElement {
    connectedCallback() {
      if(this.dataset.ready)return;
      this.dataset.ready='true';
      const data=JSON.parse(this.querySelector('[data-uw-data]').textContent);
      const label=data.labels;
      const defaults={size:'D',view:'top',mattress:'RG',timber:'WN_oil',deck:'slats',side:'right'};
      const permitted={size:Object.keys(data.sizes),view:['top','oblique'],mattress:['RG','TT','BT'],timber:['WN_oil','WN_clear','BC_oil','BC_clear','RO_oil','RO_clear','ZK_oil','ZK_clear','RO_black'],deck:['slats','board'],side:['right','left']};
      const state={...defaults};
      const readUrl=()=>{const q=new URLSearchParams(location.search);Object.keys(defaults).forEach(k=>{state[k]=permitted[k].includes(q.get(k))?q.get(k):defaults[k];});};
      readUrl();
      const selected=()=>['MASTERWAL UNISON WIDE HEAD BED',label.new,`${state.size} / ${label[state.size]}`,label[state.mattress],label[state.timber],label[state.deck],label[state.side],`${label.head_width}: ${data.sizes[state.size].head} cm / ${label.depth}: 211.6 cm`,`${label.mattress_width}: ${data.sizes[state.size].mattress} cm / ${label.mattress_length}: 195 cm`,label.pending].join('\n');
      const update=(write=true)=>{
        const size=data.sizes[state.size];
        this.querySelectorAll('[data-size]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.size===state.size)));
        this.querySelectorAll('[data-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.view===state.view)));
        this.querySelectorAll('[data-view-panel]').forEach(p=>{const active=p.dataset.viewPanel===state.view;p.hidden=false;p.dataset.active=String(active);p.inert=!active;p.setAttribute('aria-hidden',String(!active));});
        this.querySelectorAll('[data-choice]').forEach(s=>s.value=state[s.dataset.choice]);
        for(const [key,value] of Object.entries({...size,thickness:data.thickness[state.mattress],height:data.height[state.mattress]}))this.querySelectorAll(`[data-num="${key}"]`).forEach(e=>e.textContent=String(value));
        this.querySelector('[data-bar="head"]').setAttribute('width',size.head);
        this.querySelector('[data-bar="mattress"]').setAttribute('width',size.mattress);
        this.querySelector('[data-uw-summary]').textContent=[`${state.size} / ${label[state.size]}`,label[state.mattress],label[state.timber],label[state.deck],label[state.side]].join('\n');
        this.querySelector('[data-uw-form-summary]').value=selected();
        this.querySelector('[data-official]').href=`https://www.masterwal.jp/shop/g/gONLM-UNBD-${state.size}-WH/`;
        const url=new URL(location.href);Object.entries(state).forEach(([k,v])=>url.searchParams.set(k,v));
        this.querySelector('[data-uw-url]').value=url.href;
        if(write)history.replaceState(null,'',url);
      };
      this.addEventListener('click',e=>{
        const size=e.target.closest('[data-size]'),view=e.target.closest('[data-view]');
        if(size){state.size=size.dataset.size;update();}
        if(view){state.view=view.dataset.view;update();}
      });
      this.querySelectorAll('[data-choice]').forEach(s=>s.addEventListener('change',()=>{state[s.dataset.choice]=s.value;update();}));
      this.querySelector('[data-uw-copy]').addEventListener('click',async()=>{
        update();const field=this.querySelector('[data-uw-url]'),status=this.querySelector('[data-uw-status]');
        try{await navigator.clipboard.writeText(field.value);status.textContent=label.copied;}catch{field.hidden=false;field.focus();field.select();status.textContent=label.copy_failed;}
      });
      this.querySelector('[data-uw-download]').addEventListener('click',()=>{
        const url=URL.createObjectURL(new Blob([selected()+'\n\n'+this.querySelector('[data-uw-url]').value],{type:'text/plain;charset=utf-8'}));
        const a=document.createElement('a');a.href=url;a.download='MASTERWAL-UNISON-WIDE-HEAD-specification.txt';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
      });
      this._onPop=()=>{readUrl();update(false);};window.addEventListener('popstate',this._onPop);
      update(false);
    }
    disconnectedCallback(){if(this._onPop)window.removeEventListener('popstate',this._onPop);}
  });
}


  } catch(e) { console.error(e); }
})();
})();
